<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_4"></a>This is a work of fiction. All of the characters, organizations, and events<br/>portrayed in this novel are either products of the author’s imagination<br/>or are used fictitiously.</p>
<p class="para"> </p>
<p class="center-para">A TIME OF CHANGES</p>
<p class="para"> </p>
<p class="center-para">Copyright © 1971 by Agberg, Ltd.</p>
<p class="para"> </p>
<p class="center-para">Preface copyright © 2009 by Agberg, Ltd.</p>
<p class="para"> </p>
<p class="center-para">All rights reserved.</p>
<p class="para"> </p>
<p class="center-para">Originally published in 1971 by Doubleday. A shorter version<br/>of this novel was serialized in <em>Galaxy Science Fiction.</em></p>
<p class="para"> </p>
<p class="center-para">Map by Isaac Stewart</p>
<p class="para"> </p>
<p class="center-para">An Orb Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.torforge.com" target="_blank">www.torforge.com</a></p>
<p class="para"> </p>
<p class="center-para">ISBN-13: 978-0-7653-2231-9<br/>ISBN-10: 0-7653-2231-5</p>
<p class="para"> </p>
<p class="center-para">First Orb Edition: May 2009</p>
<p class="para"> </p>
<p class="center-para">Printed in the United States of America</p>
<p class="para"> </p>
<p class="center-para">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?21e7ed3c